import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { isDefined, isString, assertIsString, assert, assertIsDefined, isObject, isFunction, toJSON, fromJSON, hasProperty, CancellablePromise } from '@dateam/ark';
import Logger from '../logger';
var isJsonContentType = function isJsonContentType(response) {
  return !!(response.headers.get('content-type') && response.headers.get('content-type').toLowerCase().indexOf('application/json') >= 0);
};
var isPlainTextContentType = function isPlainTextContentType(response) {
  return !!(response.headers.get('content-type') && response.headers.get('content-type').toLowerCase().indexOf('text/plain') >= 0);
};
var generateHeaders = function generateHeaders(defaultHeaders, options) {
  var headers = defaultHeaders;
  var passToken = options.passToken,
    allowEmptyToken = options.allowEmptyToken,
    logger = options.logger,
    tokenProvider = options.tokenProvider;
  if (passToken === true) {
    var token = null;
    try {
      token = tokenProvider === null || tokenProvider === void 0 ? void 0 : tokenProvider.get();
    } catch (err) {
      if (allowEmptyToken !== true) {
        throw err;
      }
    }
    if (isString(token) && token.length > 0) headers['Authorization'] = "Bearer ".concat(token);else logger === null || logger === void 0 || logger.warn('HttpService: unable to retrieve the token.');
  }
  if (isObject(options.headers)) {
    var optionHeaders = options.headers;
    Object.keys(optionHeaders).forEach(function (headerKey) {
      if (!isString(headerKey)) {
        throw new Error('header key is not valid');
      }
      var headerValue = optionHeaders[headerKey];
      if (!headerValue || headerValue.length === 0) delete headers[headerKey];else headers[headerKey] = headerValue;
    });
  }
  return headers;
};
var fetchToHttpResponse = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(fetchResponse) {
    var response, strStatus, hasError, jsonData, errorData;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          response = {
            jsonContent: true,
            status: 0,
            body: null,
            error: null
          };
          response.status = fetchResponse.status;

          // HTTP Codes 4XX and 5XX trigger are categorized as error
          strStatus = fetchResponse.status.toString();
          hasError = strStatus.startsWith('4') || strStatus.startsWith('5');
          jsonData = null;
          if (!isJsonContentType(fetchResponse)) {
            _context.next = 9;
            break;
          }
          _context.next = 8;
          return fetchResponse.json();
        case 8:
          jsonData = _context.sent;
        case 9:
          if (!isDefined(jsonData)) {
            _context.next = 14;
            break;
          }
          response.body = fromJSON(toJSON(jsonData));
          if (hasError) {
            if (hasProperty(jsonData, 'code') && hasProperty(jsonData, 'message')) {
              errorData = jsonData;
              response.error = {
                code: errorData.code,
                message: errorData.message
              };
            } else {
              response.error = {
                code: null,
                message: null
              };
            }
          }
          _context.next = 28;
          break;
        case 14:
          response.jsonContent = false;
          response.body = fetchResponse;
          if (hasError) {
            _context.next = 20;
            break;
          }
          response.error = null;
          _context.next = 28;
          break;
        case 20:
          if (!isPlainTextContentType(fetchResponse)) {
            _context.next = 27;
            break;
          }
          _context.next = 23;
          return fetchResponse.text();
        case 23:
          _context.t0 = _context.sent;
          response.error = {
            code: null,
            message: _context.t0
          };
          _context.next = 28;
          break;
        case 27:
          response.error = {};
        case 28:
          return _context.abrupt("return", response);
        case 29:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchToHttpResponse(_x) {
    return _ref.apply(this, arguments);
  };
}();
var isContentTypeOverrode = function isContentTypeOverrode(headers) {
  return isObject(headers) && Object.keys(headers).some(function (headerKey) {
    return headerKey.toLowerCase() === 'content-type';
  });
};
var sendRequest = function sendRequest(url, method, options) {
  assertIsString(url, 'input url is not valid');
  assert(['GET', 'POST', 'PUT', 'DELETE'].includes(method), 'input method is not valid');
  assertIsDefined(options, 'input options are not valid');
  var response = {
    jsonContent: true,
    status: 0,
    body: null,
    error: null
  };

  // Create a new AbortController instance for this request
  var controller = new AbortController();
  // Get the abortController's signal
  var signal = controller.signal;
  var promise;
  try {
    var headers = generateHeaders({
      'Content-Type': 'application/json'
    }, options);
    var initData = {
      method: method.toLowerCase(),
      headers: headers,
      signal: signal
    };
    var contentTypeOverridden = isContentTypeOverrode(options.headers);

    // let fetchResponse: Response;
    switch (method) {
      case 'GET':
      case 'DELETE':
        var urlObject = new URL(url);
        if (isObject(options.params)) {
          var params = options.params;
          Object.keys(params).forEach(function (key) {
            return urlObject.searchParams.append(key, params[key]);
          });
        }
        promise = fetch(urlObject, initData);
        // fetchResponse = await fetch(urlObject, initData);
        break;
      case 'POST':
      case 'PUT':
        initData.body = contentTypeOverridden ? options.data : toJSON(options.data);
        promise = fetch(url, initData);
        // fetchResponse = await fetch(url, initData);
        break;
      default:
        throw new Error('Unhandled http method.');
    }
  } catch (err) {
    var _ref2;
    console.log('HTTP SERVICE');
    console.log(err);
    response.error = {
      code: '',
      message: (_ref2 = err instanceof Error ? err === null || err === void 0 ? void 0 : err.message : null) !== null && _ref2 !== void 0 ? _ref2 : ''
    };
  }
  var cancellablePromise = new CancellablePromise( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve, reject) {
      var result, _ref4, _response;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return promise;
          case 3:
            result = _context2.sent;
            resolve(fetchToHttpResponse(result));
            _context2.next = 11;
            break;
          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            _response = {
              jsonContent: true,
              status: 0,
              body: null,
              error: {
                code: '',
                message: (_ref4 = _context2.t0 instanceof Error ? _context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message : null) !== null && _ref4 !== void 0 ? _ref4 : ''
              }
            };
            resolve(_response);
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[0, 7]]);
    }));
    return function (_x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }(), function () {
    return controller.abort();
  });
  return cancellablePromise;
};
var HttpService = /*#__PURE__*/function () {
  function HttpService() {
    _classCallCheck(this, HttpService);
    this._logger = void 0;
    this._tokenProvider = void 0;
    this._allowEmptyToken = false;
  }
  return _createClass(HttpService, [{
    key: "get",
    value: function get(url, params) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        passToken: true
      };
      return sendRequest(url, 'GET', {
        params: params,
        passToken: options.passToken,
        headers: options.headers,
        allowEmptyToken: this._allowEmptyToken,
        tokenProvider: this._tokenProvider,
        logger: this._logger
      });
    }
  }, {
    key: "post",
    value: function post(url, data) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        passToken: true
      };
      return sendRequest(url, 'POST', {
        data: data,
        passToken: options.passToken,
        headers: options.headers,
        allowEmptyToken: this._allowEmptyToken,
        tokenProvider: this._tokenProvider,
        logger: this._logger
      });
    }
  }, {
    key: "put",
    value: function put(url, data) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        passToken: true
      };
      return sendRequest(url, 'PUT', {
        data: data,
        passToken: options.passToken,
        headers: options.headers,
        allowEmptyToken: this._allowEmptyToken,
        tokenProvider: this._tokenProvider,
        logger: this._logger
      });
    }
  }, {
    key: "delete",
    value: function _delete(url, params) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        passToken: true
      };
      return sendRequest(url, 'DELETE', {
        params: params,
        passToken: options.passToken,
        headers: options.headers,
        allowEmptyToken: this._allowEmptyToken,
        tokenProvider: this._tokenProvider,
        logger: this._logger
      });
    }
  }, {
    key: "setLogger",
    value: function setLogger(logger) {
      if (logger instanceof Logger) this._logger = logger;
      return this;
    }
  }, {
    key: "setTokenProvider",
    value: function setTokenProvider(provider) {
      if (isFunction(provider === null || provider === void 0 ? void 0 : provider.get)) this._tokenProvider = provider;
      return this;
    }
  }, {
    key: "allowEmptyToken",
    value: function allowEmptyToken() {
      this._allowEmptyToken = true;
      return this;
    }
  }, {
    key: "getFileFromResponse",
    value: function () {
      var _getFileFromResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(response) {
        var filename, contentType, contentTypeHeader, contentDispositionHeader, matchGroups, _matchGroups, filenameMatch, fileData;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(response == null)) {
                _context3.next = 2;
                break;
              }
              throw new Error('response is not valid.');
            case 2:
              _context3.prev = 2;
              filename = null;
              contentType = null;
              contentTypeHeader = response.headers.get('content-type');
              contentDispositionHeader = response.headers.get('content-disposition');
              if (contentTypeHeader != null) {
                contentType = contentTypeHeader.toLowerCase();
              }
              if (contentDispositionHeader != null && contentDispositionHeader.indexOf('attachment') === 0) {
                matchGroups = contentDispositionHeader.match(/filename="(.+)"/);
                if (matchGroups != null) {
                  _matchGroups = _slicedToArray(matchGroups, 2), filenameMatch = _matchGroups[1];
                  if (isString(filenameMatch) && filenameMatch.length > 0) {
                    filename = filenameMatch;
                  }
                }
              }
              _context3.t0 = filename;
              _context3.t1 = contentType;
              _context3.next = 13;
              return response.blob();
            case 13:
              _context3.t2 = _context3.sent;
              fileData = {
                filename: _context3.t0,
                contentType: _context3.t1,
                blob: _context3.t2
              };
              return _context3.abrupt("return", fileData);
            case 18:
              _context3.prev = 18;
              _context3.t3 = _context3["catch"](2);
            case 20:
              return _context3.abrupt("return", null);
            case 21:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[2, 18]]);
      }));
      function getFileFromResponse(_x4) {
        return _getFileFromResponse.apply(this, arguments);
      }
      return getFileFromResponse;
    }()
  }]);
}();
export default HttpService;